/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : LoadingBlock.vue
 * DESCRIPTION    : Ajax 호출 시 페이지 Dimmed 처리 블록 컴포넌트
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

<template>
    <div class="vld-parent" >
        <loading v-bind:active="getIsLoading" v-bind:is-full-page="true"></loading>
    </div>
</template>

<script>
import Loading from 'vue3-loading-overlay'
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css'

export default {
  components: {
    Loading
  },
  computed: {
    getIsLoading () {
      return this.$store.state.isLoading
    }
  }
}
</script>
